/**
 * Turns a Supabase password-check failure on the shared-device lock screen
 * into something the chef can act on. Only a genuine credential rejection
 * says the password is wrong; rate limits and outages say so, rather than
 * sending someone to reset a password that was never the problem.
 */
export function passwordCheckMessage(error: { code?: string; status?: number; message?: string }): string {
  if (error.code === "invalid_credentials") return "That password is incorrect.";
  if (error.status === 429 || error.code === "over_request_rate_limit") {
    return "Too many sign-in attempts in a short time. Wait a few minutes, then try again.";
  }
  if (error.code === "user_banned") return "This account has been suspended. Ask an administrator.";
  if (error.status === 400 && !error.code) return "That password is incorrect.";
  return `Kitchen Hub couldn't check your password right now${error.message ? ` (${error.message})` : ""}. Try again in a moment.`;
}
